import React, { useState } from "react";
import { getComputedStyles } from "../../ThemeResolver";
import { updateNode } from "../../NodeUtils";
import { useHover } from "../HoverContext";
import { NodeActions } from "../NodeActions";
import {  HoverLabel, moveNodeAction } from "../Renderer";
import { useSelection } from "../SelectionContext";
import { useDragContext } from "../DragContext";
import { useEditorMode } from "../EditorModeContext";

function renderElementContent(el) {
  switch (el.type) {
    case "header":
      return el.content;
    case "para":
      return el.content;
    case "btn":
      return el.content;
    case "image":
      return <img src={el.src} style={{ width: "100%" }} alt="" />;
    default:
      return el.content;
  }
} 

export function ElementRenderer({ element , page, setPage}) {
  const { selectedNodeId, setSelectedNodeId } = useSelection();
  const { hoverNodeId, setHoverNodeId } = useHover();

  const isSelected = selectedNodeId === element.id;
  const isHover = hoverNodeId === element.id;

  const themeStyles = getComputedStyles(element);
  const typ = element.styles?.custom?.typography || {};
const [editing, setEditing] = useState(false);
const { editMode } = useEditorMode();
const isDesign = editMode === "design";
const handleDoubleClick = () => {
  if (element.type === "header" || element.type === "para" || element.type === "btn") {
    setEditing(true);
  }
};
  const style = {
    ...themeStyles,

    // Typography live styling
    fontSize: typ.fontSize,
    color: typ.color,
    fontWeight: typ.fontWeight,
    letterSpacing: typ.letterSpacing,
    lineHeight: typ.lineHeight,
    textTransform: typ.textTransform,
    textAlign: typ.textAlign,

    outline:!isDesign||(isSelected
      ? "2px solid #1A73E8"
      : isHover
      ? "2px dashed rgba(26,115,232,0.45)"
      : "none"),
    outlineOffset: 2,
    cursor: "pointer",
    borderRadius: 4,
    position: "relative",
    transition: "all 0.15s ease",
  };
const sp = element.styles?.custom?.spacing || {};

style.marginTop = sp.marginTop;
style.marginRight = sp.marginRight;
style.marginBottom = sp.marginBottom;
style.marginLeft = sp.marginLeft;

style.paddingTop = sp.paddingTop;
style.paddingRight = sp.paddingRight;
style.paddingBottom = sp.paddingBottom;
style.paddingLeft = sp.paddingLeft;


const { draggingNodeIdRef } = useDragContext();
const handleChange = (value) => {
    const updated = { ...element, content: value };
    setPage(updateNode(page, element.id, updated));
  };
  return (
    <div
    draggable
    onDragStart={(e) => {if (!isDesign) return;
      e.stopPropagation();
 
      draggingNodeIdRef.current = element.id;
       e.dataTransfer.setData("nodeId", element.id);
    e.dataTransfer.setData("type", "element");
  }}
  onDragEnd={() => {if (!isDesign) return;
    draggingNodeIdRef.current = null;
  }}
     
  onDragOver={(e) => e.preventDefault()}
  onDrop={(e) => {if (!isDesign) return;
    const sourceId = e.dataTransfer.getData("nodeId");
    moveNodeAction(sourceId, element.id,setPage); // We'll implement this smartly
  }}

     onDoubleClick={handleDoubleClick}
     
     style={style}
      onMouseEnter={() => setHoverNodeId(element.id)}
      onMouseLeave={() =>{if (selectedNodeId !== element.id) setHoverNodeId(null);}}
      onClick={(e) => {
         if (!isDesign) return;
        e.stopPropagation();
        setSelectedNodeId(element.id);
      }}
    >
      
      <HoverLabel id={element.id} />
      {editing ? (
  <textarea
    autoFocus
    value={element.content}
    onChange={(e) => handleChange(e.target.value)}
    onBlur={() => setEditing(false)}
    onKeyDown={(e) => {
      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault();
        setEditing(false);
      }
      if (e.key === "Escape") setEditing(false);
    }}
    style={{
      width: "100%",height:`${element.content.split("\n").length*20}px`,
      border: "none",
      background: "transparent",
      outline: isDesign && isSelected ? "2px solid #1A73E8" : "none",
      resize: "none",
      overflow: "hidden",
      lineHeight: typ.lineHeight || "1.2em",
      fontSize: typ.fontSize,
      fontWeight: typ.fontWeight,
      color: typ.color,
    }}
   
  />
) : (renderElementContent(element))}
      {editing ? "":editMode === "design" && (
 <NodeActions nodeId={element.id} page={page} setPage={setPage} />
)}
    </div>
  );
}